import React, { Fragment } from "react";
import { format } from "date-fns";
import InvoiceIcon from "../../icons/invoiceIcon";
import CalendarIcon from "../../icons/calendarIcon";
import EditIcon from "../../icons/editIcon";
import TrashIcon from "../../icons/trashIcon";
import styles from "./style.module.css";
const ServiceCard = ({ service, handleEdit, handelDelete, handelDownload }) => {
  return (
    <div className={styles.service_card}>
      <div className={styles.service_card_head}>
        <div className={styles.service_card_info}>
          <div className={styles.service_card_info_date}>
            <div className={styles.service_card_info_date_item}>
              <CalendarIcon />
              <span>{format(new Date(service.date.replace('Z', '')), "dd MMM yyyy")}</span>
            </div>
            {service.mileage &&
              <Fragment>
                <div className={styles.service_card_info_date_divider} />
                <div className={styles.service_card_info_mileage}>{service.mileage}</div>
              </Fragment>
            }
            {service.cost &&
              <Fragment>
                <div className={styles.service_card_info_date_divider} />
                <div className={styles.service_card_info_cost}>${service.cost}</div>
              </Fragment>
            }

          </div>
          <div className={styles.service_card_name}>
            {service?.consumable?.name || "N/A - Non Consumable"}
          </div>
        </div>
        <div className={styles.service_card_action}>
          <button type="button" onClick={() => handleEdit(service)}>
            <EditIcon />
          </button>
          <button type="button" onClick={() => handelDelete(service)}>
            <TrashIcon />
          </button>
        </div>
      </div>
      <div className={styles.service_card_foot}>
        <div className={styles.service_card_foot_desc}>
          {service.description}
        </div>
        <div className={styles.service_card_foot_invoice}>
          {service?.attachments.map((attachment, index) => (
            <div
              key={index}
              onClick={() => handelDownload(service._id)}
              className={styles.service_card_foot_attachment}
            >
              <span>Attachment</span>
              <InvoiceIcon />
            </div>
          ))}

        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
